import { HlaWayType } from "../../../ra/models/HlaWay";

export function categorizeCompositeFeature(
  className: string,
  type: string,
): HlaWayType {
  if (type === "cycleway") {
    return HlaWayType.Cycleway;
  }
  if (type === "pedestrian") {
    return HlaWayType.Pedestrian;
  }
  if (type === "sidewalk") {
    return HlaWayType.Sidewalk;
  }
  if (type === "platform") {
    return HlaWayType.Platform;
  }

  if (className === "trunk" || className === "motorway") {
    return HlaWayType.Motorway;
  }
  if (className === "primary" || className === "primary_link") {
    return HlaWayType.Primary;
  }
  if (className === "secondary" || className === "secondary_link") {
    return HlaWayType.Secondary;
  }
  if (className === "tertiary" || className === "tertiary_link") {
    return HlaWayType.Tertiary;
  }

  if (
    className === "service" ||
    type === "residential" ||
    type === "living_street" ||
    (className === "street" && type === "road")
  ) {
    return HlaWayType.Service;
  }

  if (
    (className === "street" && type === "unclassified") ||
    className === "street_limited"
  ) {
    return HlaWayType.Unclassified;
  }

  if (
    className === "track" ||
    className === "path" ||
    type === "path" ||
    type === "footway"
  ) {
    return HlaWayType.FootPath;
  }

  console.log(`Found a new feature type: ${className}/${type}`);

  return HlaWayType.Unclassified;
}
